import React from 'react';
import { useDispatch } from 'react-redux';
import { ResetUnlockedAccount } from '../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi';
import ButtonAction from './ButtonAction';
import {IdentityT} from './IconButtons';
import {errorMsg} from "../../Apis/functions";

const BtnResetByImpersonation = ({ id }) => {
    const dispatch = useDispatch();

    const sendResetByImpersonation = () => {
        dispatch(ResetUnlockedAccount(id)).then(({payload: {data: { success, code }}}) => {
            if(!success){
                errorMsg(code);
            }
        });
    };

    return (
        <ButtonAction
            id='btn_brbi_reset_impersonation'
            name='reset_by_impersonation'
            className='btn-icon-accent-450'
            Icon={IdentityT}
            disabled={false}
            splitName={false}
            onClick={()=>{
                sendResetByImpersonation();
            }}
        />
    );
};

export default BtnResetByImpersonation;
